export interface Bonus {
  number: string
  title: string
  value: string
  description: string
}

export const bonuses: Bonus[] = [
  {
    number: '01',
    title: 'The 150-Drill Quick-Reference Library',
    value: '$27',
    description: 'Every drill you’ll ever need, categorised and ready.',
  },
  {
    number: '02',
    title: 'The “Magic Cues” Cheat Sheet',
    value: '$27',
    description:
      '100 common errors and the exact words to fix them instantly.',
  },
  {
    number: '03',
    title: 'The Games & Challenges Catalog',
    value: '$19',
    description:
      '75 competitive activities to make your lessons the most fun in town.',
  },
  {
    number: '04',
    title: 'The Ultimate Assessment System',
    value: '$19',
    description:
      'Professional rubrics to track and prove student progress.',
  },
  {
    number: '05',
    title: 'Emergency Lesson Plans & Clinics',
    value: '$19',
    description: 'The 5-minute lifesaver for last-minute sessions.',
  },
  {
    number: '06',
    title: 'Injury Prevention Guide',
    value: 'Included',
    description: 'Warm-ups and safety protocols that protect your players.',
  },
  {
    number: '07',
    title: 'The Pro Coach Welcome Packet',
    value: 'Included',
    description: 'Professional onboarding from the very first handshake.',
  },
]

export const bonusTotalValue = '$111'
